<template>
    <div class="freeMaterial">
        <div class="freeMaterial-body">
            <div class="search">
                素材作者 : {{searchParams.author}}
                <!-- <el-select size="mini" style="width: 144px" v-model="searchParams.author" :clearable="false" @change="handleAuthorChange">
                    <el-option v-for="item in authorList" :label="item" :value="item"></el-option>
                </el-select> -->
            </div>
            <!-- 素材列表 -->
            <free-material-list :tab="searchParams" author materialType="1" />
        </div>
    </div>
</template>

<script>
import FreeMaterialList from './MaterialList';
import { getAllMateiralAuthor } from '@/api/material'

export default {
    name: 'MaterialAuthor',
    components: {
        FreeMaterialList,
    },
    data: () => ({
        searchParams:{
            author:""
        },
        authorList:[]
    }),
    created() {
        this.searchParams.author = this.$route.params.id
    },
    mounted() {
        this.getAllAuthor();
    },
    methods: {
        getAllAuthor() {
            getAllMateiralAuthor().then(res => {
                this.authorList = res.data || []
            })
        },
        handleAuthorChange(authorName) {
            const nextDetailUrl = `${location.origin}#/material/author/${authorName}`
            history.pushState({
                url: nextDetailUrl,
                title: document.title
            },document.title, nextDetailUrl)
        }
    }
};
</script>

<style lang="scss" scoped>
.freeMaterial {
    &-tabs {
        padding-bottom: 10px;
		border-bottom: 1px solid rgba(224, 228, 247, 1);
        margin-bottom: 10px;
		.base-tabs {
			// margin-bottom: 20px;
		}
	}
	&-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
        > img {
            cursor: pointer;
            flex:1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
            font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
        }
    }
    
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        width: 1600px;
        /deep/ .el-tabs__content {
            overflow: visible;
        }
        /deep/ .el-tabs__item {
            font-size: 18px;
            color: #272c40;
            &.is-active {
                color:#2C54EF;
                font-weight: 600;
            }
        }
        /deep/ .el-select {
            width: 110px;
            input {
                font-size: 16px;
                color: #2c54ef;
            }
        }
        .icon-new-top {
            position: absolute;
            right: 0px;
            top: 0px;
        }
        /deep/ .el-input__inner {
            background: #f5f6f9;
        }
    }
    .tab-item {
        margin-bottom: 9px;
        color:#a4a7b4;
        font-size: 16px;
        span {
            margin-right: 20px;
            padding: 3px 8px;
            display: inline-block;
            color: #272c40;
            font-size: 16px;
            cursor: pointer;
            position: relative;
            &.active {
                color: #2F54EB;
                background: #DCE3FD;
                border-radius: 4px;
            }
            .icon-new {
                position: absolute;
                right: 0px;
                top: -10px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .freeMaterial {
        &-tabs {
            padding-bottom: 4px;
			.base-tabs {
				margin-bottom: 14px;
			}
        }
    }
}
</style>
